/**
* content
*/

import Component, { debounce, subscribe } from "../../js/lib/component";
import $ from 'jquery';
import Page from "../page/page";
import anime from 'animejs/lib/anime.js';

const classList = {
  root: ".js-content",
  sidebar: ".js-content-sidebar",
  overlay: ".js-content-overlay",
};

export default class Content extends Component {
  events() {
    subscribe('sidebar:show', () => this.showSidebar());
    subscribe('sidebar:hide', () => this.hideSidebar());
    subscribe('page:esc', () => this.hideSidebar());
    subscribe('page:resize', debounce(() => this.hideSidebar(), 600));
    this.$.overlay.on('click', () => this.hideSidebar());
  }
  showSidebar() {
    if (this.get('visible')) return;

    const overlay = this.$.overlay.get();
    const sidebar = this.$.sidebar.get();

    anime.set(sidebar, { display: 'block', translateX: '-100%' });
    anime.set(overlay, { display: 'block', opacity: 0 });

    Page.bodyOverflowEnable();

    Promise.all([
      anime({
        targets: overlay,
        easing: 'easeOutCubic',
        duration: 450,
        opacity: 0.6
      }).finished,
      anime({
        targets: sidebar,
        easing: 'easeOutCubic',
        duration: 450,
        translateX: 0
      }).finished
    ]).then(() => {
      this.set({ visible: true });
    });
  }
  hideSidebar() {
    if (!this.get('visible')) return;

    const overlay = this.$.overlay.get();
    const sidebar = this.$.sidebar.get();

    Promise.all([
      anime({
        targets: overlay,
        easing: 'easeOutCubic',
        duration: 450,
        opacity: 0
      }).finished,
      anime({
        targets: sidebar,
        easing: 'easeOutCubic',
        duration: 450,
        translateX: '-100%'
      }).finished
    ]).then(() => {
      anime.set(sidebar, { display: 'none' });
      anime.set(overlay, { display: 'none' });

      Page.bodyOverflowDisable();

      this.set({ visible: false });
    });
  }
}

Component.mount(Content, {
  name: "Content",
  classList,
  state: {
    visible: false
  }
});
